import InputField from "features/Library/Common/Fields/InputField";
import { WithFormikPayload } from "features/Library/Common/Fields/WithFormikPayload";
import { MAX_QUESTION_FIELD_LENGTH } from "features/Library/Common/constants";
import { type QuestionPropsBase } from "features/Library/Common/QuestionsForm/types";
import styles from "features/Library/Common/QuestionsForm/Questions/QuestionFields/TextQuestion/TextQuestion.module.scss";

export type TextQuestionProps = Omit<QuestionPropsBase<string>, "propertyNamePrefix"> & { propertyName: string };

export const TextQuestion = (props: TextQuestionProps) => {
  const { question, onBlur, disabled, validatedFieldProps, propertyName = "" } = props;
  const { setFieldValue, setFieldTouched } = validatedFieldProps;

  return (
    <div className={styles.container}>
      <WithFormikPayload
        propertyName={propertyName}
        {...validatedFieldProps}
        selfValidation
        render={(formikProps) => (
          <InputField
            useTextarea
            placeholder={"Question"}
            value={question}
            maxLength={MAX_QUESTION_FIELD_LENGTH}
            errorPosition={"bottom"}
            onBlur={onBlur}
            disabled={disabled}
            setFieldTouched={setFieldTouched}
            setFieldValue={setFieldValue}
            {...formikProps}
          />
        )}
      />
    </div>
  );
};
